import React from 'react'

import { Box, Tooltip } from '@chakra-ui/react'
import { camelToWords } from '@/utils/stringHelper'

export const TooltipCellRenderer = ({ cell: { value } }) => <TooltipCell text={value} />
export const TooltipCellRenderer2 = ({ cell: { getValue } }) => <TooltipCell text={getValue()} />
export const NormalTextCellRenderer = ({ cell: { getValue } }) => <TooltipCell text={camelToWords(getValue())} />

export const TooltipCell = ({ text, tooltip = text, color = 'black' }) => (
  <Tooltip label={tooltip}>
    <Box color={color}>{text}</Box>
  </Tooltip>
)
